import { BrowserModule } from '@angular/platform-browser';
import { NgModule, SecurityContext } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from './core/core.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ClientsModule } from './clients/clients.module';
import { PriceListsModule } from './price-lists/price-lists.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { EventsModule } from './events/events.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompaniesModule } from './companies/companies.module';
import { PrintersModule } from './printers/printers.module';
import { DevicesModule } from './devices/devices.module';
import { RoutersModule } from './routers/routers.module';
import { OffersModule } from './offers/offers.module';
import { SettingsModule } from './settings/settings.module';
import { StatisticsModule } from './statistics/statistics.module';
import { QRCodeComponent } from 'angularx-qrcode';
import { AgentsModule } from './agents/agents.module';
import { LMarkdownEditorModule } from 'ngx-markdown-editor';
import { MarkdownModule } from 'ngx-markdown';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BlogsModule } from './blogs/blogs.module'
import { LeafletDirective, LeafletModule } from '@bluehalo/ngx-leaflet';
import { NgxTurnstileFormsModule, NgxTurnstileModule } from 'ngx-turnstile';

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home' }
];

const translationConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient]
  }
};

const toastrConfig = {
  closeButton: true,
  progressBar: true,
  positionClass: 'toast-bottom-left',
  timeOut: 3000
};

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RouterModule.forRoot(routes),
        TranslateModule.forRoot(translationConfig),
        ToastrModule.forRoot(toastrConfig),
        BrowserAnimationsModule,
        JwtModule.forRoot({ config: { tokenGetter: tokenGetter, headerName: 'X-Access-Token' } }),
        NgHttpLoaderModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        LeafletModule,
        LeafletDirective,
        FormsModule,
        ReactiveFormsModule,
        ClientsModule,
        CoreModule,
        PriceListsModule,
        EventsModule,
        CompaniesModule,
        PrintersModule,
        DevicesModule,
        RoutersModule,
        OffersModule,
        SettingsModule,
        StatisticsModule,
        QRCodeComponent,
        LMarkdownEditorModule,
        AgentsModule,
        MarkdownModule.forRoot({ sanitize: SecurityContext.NONE }),
        InputsModule,
        NgxTurnstileModule,
        NgxTurnstileFormsModule,
        BlogsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json`);
}
